/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.26.0
 * @since 1.25.0
 */

import { TNotificationsSettingsForm } from './types';

export const defaultNotificationsSettingsFormValues: TNotificationsSettingsForm = {
    showNotifications: false,
    showNews: false,
    showNotificationsOrders: false,
    showNotificationsInquiries: false,
    showNotificationsEdo: false,
    showNotificationsCashback: false,
};
